module.exports = __webpack_public_path__ + "img/raw-material.11e3154b.svg";